module.exports = __webpack_public_path__ + "img/0718430f92d9a3d65ad762cad54aff7a.png";